import angular from 'angular';

import productsListFiltersComponent from './products-list-filters.component';
import ProductsListFiltersConfig from './products-list-filters.config';
// import PriceFilterModule from './price-filter/price-filter';
// import DynamicFiltersModule from './dynamic-filters/dynamic-filters';
// import ModalAtributosValores from './modal-atributos-valores/modal-atributos-valores.controller';
// import ModalAtributos from './modal-atributos/modal-atributos.controller';
// import ProductsPageToolboxModule from './products-page-toolbox/products-page-toolbox';

let productsListFiltersModule = angular.module('productsListFilters',[
//   PriceFilterModule.name,
//   DynamicFiltersModule.name,
//   ProductsPageToolboxModule.name,npm run dev

])
//   .controller('modalAtributosValores', ModalAtributosValores)
//   .controller('modalAtributos', ModalAtributos)
  .component('productsListFilters', productsListFiltersComponent)
  .config(ProductsListFiltersConfig);

export default productsListFiltersModule;



/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/catalog/products-list-filters/products-list-filters.js
 **/